import { rydeColorsDashboardPage, rydeColorsGraphsScheme } from "@ryde/theme";

import {
  ComparingEnum,
  DashboardCardNameEnum,
  DashboardColorGraphEnum,
  DashboardGraphColorMappingEnum,
} from "../../enums";

export const colorSchemeHelper = (scheme: string): Record<string, string> => {
  if (scheme === DashboardColorGraphEnum.PURPLE) {
    return rydeColorsGraphsScheme.Purple;
  }

  if (scheme === DashboardColorGraphEnum.RED) {
    return rydeColorsGraphsScheme.Red;
  }

  if (scheme === DashboardColorGraphEnum.GREEN) {
    return rydeColorsGraphsScheme.Green;
  }

  return rydeColorsGraphsScheme.Purple;
};

// TODO: In future : Maybe change to generic?
export interface IColorPredicateOptions {
  objectToCheck: any; // TODO: fix any
  fieldToCheck: string;
  fieldValueToCheck: any; // TODO: fix any
}

interface IColorsSchemeComponent {
  mainScheme: string;
  isSame: boolean;
}

interface IColorsScheme {
  primary: IColorsSchemeComponent;
  secondary?: IColorsSchemeComponent;
}

export const cardNameToColorSchemeMap = (
  cardName: DashboardCardNameEnum,
  colorScheme: DashboardGraphColorMappingEnum,
): IColorsScheme | undefined => {
  if (
    cardName === DashboardCardNameEnum.RIDE_PAGE_MANUAL_CHANGES_PER_USER &&
    colorScheme === DashboardGraphColorMappingEnum.SINGLE_COLOR
  ) {
    return {
      primary: { mainScheme: DashboardColorGraphEnum.PURPLE, isSame: true },
    };
  }

  if (
    cardName === DashboardCardNameEnum.VEHICLE_TYPE_RIDES_COST &&
    colorScheme ===
      DashboardGraphColorMappingEnum.DIFFERENT_COLORS_WITH_CONDITION
  ) {
    return {
      primary: { mainScheme: DashboardColorGraphEnum.GREEN, isSame: false },
      secondary: { mainScheme: DashboardColorGraphEnum.RED, isSame: false },
    };
  }

  if (
    cardName === DashboardCardNameEnum.RIDES_SUPPLIERS &&
    colorScheme === DashboardGraphColorMappingEnum.TWO_COLORS_WITH_CONDITION
  ) {
    return {
      primary: { mainScheme: DashboardColorGraphEnum.PURPLE, isSame: true },
      secondary: { mainScheme: DashboardColorGraphEnum.RED, isSame: true },
    };
  }

  return undefined;
};

export const pickGraphColors = (
  cardName: DashboardCardNameEnum,
  colorScheme: DashboardGraphColorMappingEnum,
  fieldName: string,
  fieldValueToGetSecondaryValue: any, // TODO: fix any
  content: any[], // TODO: fix any
  predicateFunction: (options: IColorPredicateOptions) => boolean,
  preferredColorOption = 1,
): string[] => {
  const selectedColors: string[] = [];
  const schemesData = cardNameToColorSchemeMap(cardName, colorScheme);

  if (content.length === 0 || !schemesData) {
    return selectedColors;
  }

  if (!schemesData.secondary) {
    const { mainScheme, isSame } = schemesData.primary;
    const colors = colorSchemeHelper(mainScheme);

    if (!isSame) {
      return content.map((_, index) => colors[`${mainScheme}${index + 1}`]);
    }

    const validPreferredColorOption =
      preferredColorOption <= 22 && preferredColorOption >= 1
        ? preferredColorOption
        : 1;
    return content.map(
      _ => colors[`${mainScheme}${validPreferredColorOption}`],
    );
  }

  const [primary, secondary] = [schemesData.primary, schemesData.secondary];
  const [primaryColorScheme, secondaryColorScheme] = [
    colorSchemeHelper(primary.mainScheme),
    colorSchemeHelper(secondary.mainScheme),
  ];
  let [primaryCounter, secondaryCounter] = [1, 1];
  content.forEach(ele => {
    if (
      predicateFunction({
        objectToCheck: ele,
        fieldToCheck: fieldName,
        fieldValueToCheck: fieldValueToGetSecondaryValue,
      })
    ) {
      // if it matched the condition apply secondary
      selectedColors.push(
        secondaryColorScheme[`${secondary.mainScheme}${secondaryCounter}`],
      );

      if (!secondary.isSame) {
        secondaryCounter++;
      }
    } else {
      selectedColors.push(
        primaryColorScheme[`${primary.mainScheme}${primaryCounter}`],
      );

      if (!primary.isSame) {
        primaryCounter++;
      }
    }
  });
  return selectedColors;
};

export const pickNumericCardSubheaderColor = (
  comparingEnum: ComparingEnum,
): string => {
  if (comparingEnum === ComparingEnum.BAD) {
    return rydeColorsDashboardPage.redTextNumeric;
  }

  return rydeColorsDashboardPage.greenTextNumeric;
};
